webpackJsonp([2],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40052f2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(470)(true);
// imports


// module
exports.push([module.i, "h2[data-v-40052f2c]{color:#fff;font-size:30px;text-align:center;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", "", {"version":3,"sources":["/Users/warren/Desktop/sites/gitlab/online/VD/src/components/notfound.vue"],"names":[],"mappings":"AACA,oBACE,WAAa,AACb,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAC1C","file":"notfound.vue","sourcesContent":["\nh2[data-v-40052f2c] {\n  color: white;\n  font-size: 30px;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(646);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(471)("045ab618", content, true);

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site__container"
    }
  }, [_c('h2', [_vm._v("Error, page not found!")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.60debeba761f4240fc91.js